import { isValid } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  formatDate,
  formatDateTime,
} from '~/modules/impacted-companies/components/utils';

import styles from './PublishedDate.module.scss';

interface PublishedDateProps {
  publishedAt: string;
  updatedAt?: string;
  isPreview?: boolean;
  fiscalYear?: number;
  fiscalPeriod?: string;
  releasedAt?: string;
}

const SEPARATOR = ' · ';

export const PublishedDate = ({
  publishedAt,
  updatedAt,
  isPreview,
  fiscalYear,
  fiscalPeriod,
  releasedAt,
}: PublishedDateProps) => {
  const { t } = useTranslation(['earnings']);

  const formattedPublished =
    publishedAt && isValid(new Date(publishedAt))
      ? formatDateTime(new Date(publishedAt))
      : '';
  const formattedUpdated =
    updatedAt && isValid(new Date(updatedAt))
      ? formatDateTime(new Date(updatedAt))
      : '';
  const formattedReleased =
    releasedAt && isValid(new Date(releasedAt))
      ? formatDate(new Date(releasedAt))
      : '';

  const parts: string[] = [];

  if (formattedPublished) {
    parts.push(
      t('earningsInsight.metadata.publishedWithDate', {
        date: formattedPublished,
      })
    );
  }

  if (!isPreview) {
    if (formattedUpdated) {
      parts.push(
        t('earningsInsight.metadata.updatedWithDate', {
          date: formattedUpdated,
        })
      );
    }

    const hasEarningsContext =
      !!fiscalPeriod && !!fiscalYear && !!formattedReleased;

    if (hasEarningsContext) {
      parts.push(
        t('earningsInsight.metadata.basedOnEarnings', {
          period: `${fiscalPeriod} ${fiscalYear}`,
          releasedDate: formattedReleased,
        })
      );
    }
  }

  const label = parts.join(SEPARATOR);

  if (!label) {
    return null;
  }

  return <div className={styles.wrapper}>{label}</div>;
};
